<template>
  <div>
    <div v-if="feedbackNotes && agent" class="overview-notes-container">
      <template v-if="feedbackNotes.length">
        <div v-for="(note, index) in feedbackNotes" :key="index" class="note">
          <span class="overview-note-name">{{ getNoteCreatorName(note) }}:  </span>
          <span>{{ formatDate(note._timestamp) }} - </span>
          <span class="overview-note-text">{{ note.text }}</span>
        </div>
      </template>
      <div v-else-if="isMobile">
        Notes are not filled
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  props: {
    feedbackNotes: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    ...mapState('agent', ['agentData']),
    ...mapState('client', ['clientData', 'associatedAgent']),
    ...mapState('common', ['isMobile']),
    agent() {
      return this.associatedAgent ? this.associatedAgent : this.agentData
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MM-DD-YYYY, h:mm a')
    },
    getNoteCreatorName(note) {
      const name = note._creator === this.agent._id ? this.agent.name : this.clientData.name
      return name
    }
  }
}
</script>
<style lang="sass">
.overview-notes-container
  margin-top: 1rem
  max-height: 400px
  overflow: auto
.overview-notes-container .note:not(:first-child)
  padding-top: 8px
.overview-notes-container .note
  text-align: left
.overview-notes-container span:not(:last-child)
  font-weight: bold
.overview-note-name
  text-transform: capitalize
</style>
